import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33b67eba"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("恢复")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("彻底删除")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _directive_perm = _resolveDirective("perm")!

  return (_openBlock(), _createBlock(_component_a_space, null, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
        loading: _ctx.loading,
        disabled: _ctx.selectedIds.length === 0,
        type: "primary",
        onClick: _ctx.onRecover
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["loading", "disabled", "onClick"])), [
        [_directive_perm, _ctx.recycleBinConfig.recoverPremKey]
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
        loading: _ctx.loading,
        disabled: _ctx.selectedIds.length === 0,
        type: "primary",
        danger: "",
        onClick: _ctx.onDelete
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["loading", "disabled", "onClick"])), [
        [_directive_perm, _ctx.recycleBinConfig.deletePremKey]
      ])
    ]),
    _: 1
  }))
}